var airbus = require("../dist/js/airbus");
var airbusImages = require("../dist/js/airbus/images");
var skywise = require("../dist/js/skywise");
var skywiseImages = require("../dist/js/skywise/images");
module.exports = {
  airbus: { ...airbus, ...airbusImages },
  skywise: { ...skywise, ...skywiseImages }
};
